import React, {useState} from "react";
import ProfileContainer from "../components/ProfileContainer";
import ProfileReferenceRow from "../components/ProfileReferenceRow";
import {useAuth} from "../../../providers/AuthProvider";

const MAX_LENGTH = 3;


const TalentProfileReferences = ({items = []}) => {
    const [isMoreOpen, setIsMoreOpen] = useState(false);
    const auth = useAuth();

    const references = items.filter(ref => !!ref.is_confirmed);
    const canShowContact = auth.user().canManageTalent() || auth.user().canManageClients();

    return (
        <div id="references" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">References  {!!references.length && `(${references.length})`}</h4>

                    {!references.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No References Available</p>
                        </div>
                    )}

                    <div className="flex flex-col divide-y">
                        {references?.slice(0, isMoreOpen ? references.length : MAX_LENGTH).map(reference => (
                            <ProfileReferenceRow key={reference.id} showContact={canShowContact} reference={reference} />
                        ))}
                    </div>

                    {references.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsMoreOpen(!isMoreOpen)}
                            >
                                <p>{references.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isMoreOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>
    )
}

export default TalentProfileReferences;